module.exports = __webpack_public_path__ + "static/media/18.45e183de.ogg";